"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _queryString = require("query-string");

var _queryString2 = _interopRequireDefault(_queryString);

var _ClearFilter = require("./ClearFilter");

var _ClearFilter2 = _interopRequireDefault(_ClearFilter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var addQueryToResult = function addQueryToResult(result, param, query) {
  var filterResult = Object.keys(query).map(function (key) {
    return [key, query[key]];
  });
  return [].concat(_toConsumableArray(result), _toConsumableArray(filterResult));
};

var getFilterDefaultQuery = function getFilterDefaultQuery(result, filter) {
  if (filter.type.getDefaultQuery) {
    var defaultQuery = filter.type.getDefaultQuery(filter.props);
    return addQueryToResult(result, filter.props.param, defaultQuery);
  }

  return result;
};

var getFilterCurrentQuery = function getFilterCurrentQuery(result, filter, context) {
  var param = filter.props.param;


  if (filter.type.getCurrentQuery) {
    var currentQuery = filter.type.getCurrentQuery(filter.props, context);
    result = addQueryToResult(result, param, currentQuery);
  } else {
    var query = context.location.query;

    result = [].concat(_toConsumableArray(result), [[param, query[param]]]);
  }

  return result;
};

var getDefaultParams = function getDefaultParams(filters) {
  return I.OrderedMap(filters.reduce(function (result, filter) {
    return getFilterDefaultQuery(result, filter);
  }, [])).toJS();
};

var getCurrentParams = function getCurrentParams(filters, context) {
  return I.OrderedMap(filters.reduce(function (result, filter) {
    return getFilterCurrentQuery(result, filter, context);
  }, []).filter(function (item) {
    return item[1];
  })).toJS();
};

var FilterSet = (_temp2 = _class = function (_Component) {
  _inherits(FilterSet, _Component);

  function FilterSet() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilterSet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterSet.__proto__ || Object.getPrototypeOf(FilterSet)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (_ref2) {
      var pathname = _ref2.pathname,
          query = _ref2.query;

      _this.context.history.push({
        pathname: pathname,
        search: "?" + _queryString2.default.stringify(_extends({}, query, _this.props.queryToReset || {}))
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilterSet, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className;

      var filters = Array.isArray(children) ? children : [children];
      var filterForClear = filters.filter(function (_ref3) {
        var noReset = _ref3.props.noReset;
        return !noReset;
      });

      return _react2.default.createElement(
        "div",
        { className: (0, _classnames2.default)("erg-components-FilterSet", "erg-font-sm", "pull-right", className) },
        filters.map(function (filter, idx) {
          return (0, _react.cloneElement)(filter, {
            className: (0, _classnames2.default)({
              "erg-margin-right-10": idx < filters.length - 1
            }),
            key: filter.key || idx, // TODO: Why not to use `filter.props.param` instead?
            onChange: _this2.handleChange
          });
        }),
        _react2.default.createElement(_ClearFilter2.default, {
          activeFilters: getCurrentParams(filterForClear, this.context),
          className: "erg-margin-right-5",
          defaultFilters: getDefaultParams(filters),
          onClear: this.handleChange })
      );
    }
  }], [{
    key: "getCurrentQuery",


    // TODO: Find a way to make it as normal method, but still call it before
    // initial data loading
    value: function getCurrentQuery(filters, context) {
      filters = Array.isArray(filters) ? filters : [filters];

      return _extends({}, getDefaultParams(filters), getCurrentParams(filters, context));
    }
  }]);

  return FilterSet;
}(_react.Component), _class.displayName = "FilterSet", _class.contextTypes = {
  location: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired
}, _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.node]).isRequired,
  className: _propTypes2.default.string,
  queryToReset: _propTypes2.default.object }, _temp2);
exports.default = FilterSet;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/filters/FilterSet.js
 ** module id = 793
 ** module chunks = 0
 **/